<div class="user-detail-drawer">
  <!-- ════ HEADER BAR ════ -->
  <div class="drawer-header">
    <div class="header-left">
      <span class="header-badge">
        <i class="fas fa-id-card"></i> Ficha de Utilizador
      </span>
      <h2 class="drawer-title">Detalhes da Conta</h2>
    </div>

    <button type="button" class="btn-close-drawer" (click)="closeDetalhe()" title="Fechar">
      <i class="fas fa-xmark"></i>
    </button>
  </div>

  <div class="drawer-body">
    <!-- ════ PROFILE HERO CARD ════ -->
    <div class="profile-hero-card">
      <div class="profile-avatar">
        {{ (utilizador()?.userName ? utilizador().userName[0] : 'U') | uppercase }}
      </div>

      <div class="profile-info">
        <div class="profile-name-row">
          <h3 class="profile-name">{{ utilizador()?.userName || "Nome não informado" }}</h3>
          <span class="status-pill-verified">
            <i class="fas fa-circle-check"></i> Verificado
          </span>
        </div>
        <div class="profile-meta">
          <span><i class="fas fa-globe text-primary"></i> Angolano</span>
          <span><i class="fas fa-envelope text-secondary"></i> {{ utilizador()?.email || "Sem email" }}</span>
        </div>
      </div>
    </div>

    <!-- ════ PERSONAL & ACCOUNT INFO GRID ════ -->
    <div class="section-card">
      <h4 class="section-title">
        <i class="fas fa-user-gear text-primary"></i> Informações Cadastrais
      </h4>

      <div class="info-tiles-grid">
        <!-- Telefone -->
        <div class="info-tile">
          <div class="tile-icon phone">
            <i class="fas fa-phone"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Telefone</span>
            <strong class="tile-value">{{ utilizador()?.telefone || "Não Informado" }}</strong>
          </div>
        </div>

        <!-- Data de Nascimento -->
        <div class="info-tile">
          <div class="tile-icon calendar">
            <i class="fas fa-cake-candles"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Data de Nascimento</span>
            <strong class="tile-value">{{ (utilizador()?.dataNascimento | date: 'dd/MM/yyyy') || "Não Informada"
              }}</strong>
          </div>
        </div>

        <!-- NIF / BI -->
        <div class="info-tile">
          <div class="tile-icon nif">
            <i class="fas fa-id-badge"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">NIF / Nº Identificação</span>
            <strong class="tile-value mono">{{ utilizador()?.numeroDocumento || "Não Informado" }}</strong>
          </div>
        </div>

        <!-- Email -->
        <div class="info-tile">
          <div class="tile-icon email">
            <i class="fas fa-envelope"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Email Principal</span>
            <strong class="tile-value">{{ utilizador()?.email || "Não Informado" }}</strong>
          </div>
        </div>

        <!-- Data de Registo -->
        <div class="info-tile">
          <div class="tile-icon reg-date">
            <i class="fas fa-calendar-check"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Membro Desde</span>
            <strong class="tile-value">{{ utilizador()?.dataCriacaoFormatada || "Não Informado" }}</strong>
          </div>
        </div>

        <!-- IBAN -->
        <div class="info-tile">
          <div class="tile-icon iban">
            <i class="fas fa-building-columns"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">IBAN Associado</span>
            <strong class="tile-value mono">{{ utilizador()?.iban || "Não Informado" }}</strong>
          </div>
        </div>
      </div>
    </div>

    <!-- ════ DONATIONS HISTORY ════ -->
    <div class="section-card">
      <div class="section-header-flex">
        <h4 class="section-title mb-0">
          <i class="fas fa-hand-holding-heart text-primary"></i> Histórico de Doações
        </h4>
        <span class="records-pill" *ngIf="pagination?.totalRecords !== undefined">
          {{ pagination.totalRecords }} apoios
        </span>
      </div>

      <div class="table-container mt-3">
        <ng-container *ngIf="pagamentos?.length; else noPayments">
          <p-table [value]="pagamentos" stripedRows [tableStyle]="{ 'min-width': '100%' }" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Campanha</th>
                <th>Meta</th>
                <th>Valor Doado</th>
                <th>Estado</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-payment>
              <tr>
                <td class="font-medium text-main">
                  {{ payment?.campanha?.titulo || "Campanha" }}
                </td>
                <td class="text-secondary text-sm">
                  {{ (payment?.campanha?.metaArrecadar || 0) | money }} Kz
                </td>
                <td class="font-semibold text-primary">
                  {{ (payment?.valorDoadoTotal || 0) | money }} Kz
                </td>
                <td>
                  <p-tag [severity]="getSeverityPayment(payment?.estadoApoio)" [value]="payment?.estadoApoio"></p-tag>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="pagination-wrapper mt-3">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
              [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
              (pageChange)="onPagePayment($event)">
            </app-paginator-control>
          </div>
        </ng-container>

        <ng-template #noPayments>
          <div class="nodata-box">
            <app-data-void titulo="Nenhum apoio registado"
              descricao="Este utilizador ainda não efectuou nenhuma doação."></app-data-void>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- ════ CREATED CAMPAIGNS ════ -->
    <div class="section-card">
      <div class="section-header-flex">
        <h4 class="section-title mb-0">
          <i class="fas fa-bullhorn text-primary"></i> Campanhas Criadas
        </h4>
        <span class="records-pill" *ngIf="cpm_pagaination?.totalRecords !== undefined">
          {{ cpm_pagaination.totalRecords }} projectos
        </span>
      </div>

      <div class="table-container mt-3">
        <ng-container *ngIf="campanhas?.length; else noCampanhas">
          <p-table [value]="campanhas" stripedRows [tableStyle]="{ 'min-width': '100%' }" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Título</th>
                <th>Meta</th>
                <th>Arrecadado</th>
                <th>Estado</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-campanha>
              <tr>
                <td class="font-medium text-main">
                  {{ campanha?.titulo }}
                </td>
                <td class="text-secondary text-sm">
                  {{ (campanha?.metaArrecadar || 0) | money }} Kz
                </td>
                <td class="font-semibold text-primary">
                  {{ (campanha?.valorArrecado || 0) | money }} Kz
                </td>
                <td>
                  <p-tag [severity]="getSeverityCampanha(campanha?.estadoCampanha)"
                    [value]="campanha?.estadoCampanha"></p-tag>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="pagination-wrapper mt-3">
            <app-paginator-control [first]="((cpm_pagaination.pageNumber ?? 1) - 1) * (cpm_pagaination.pageSize ?? 10)"
              [rows]="cpm_pagaination.pageSize ?? 10" [totalRecords]="cpm_pagaination.totalRecords ?? 0"
              (pageChange)="onPageCPM($event)">
            </app-paginator-control>
          </div>
        </ng-container>

        <ng-template #noCampanhas>
          <div class="nodata-box">
            <app-data-void titulo="Nenhuma campanha criada"
              descricao="Este utilizador ainda não lançou nenhuma campanha na plataforma."></app-data-void>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>